import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6.5 17h11","key":"svg-0"}],["path",{"d":"M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z","key":"svg-1"}],["path",{"d":"M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z","key":"svg-2"}]]

const IconHourglassLow = createReactComponent('outline', 'hourglass-low', 'HourglassLow', __iconNode);

export default IconHourglassLow;